import config from './config';
import Socket from './Socket';

const url = config.websocketUrl;
const beep = config.beepAfterOperations; // 响应声音
const deleteflag = config.clearAfterRead; // 读取数据后是否清空
const socket = new Socket();

// 连接websocket接口
export const connect = () => {
  // socket = new Socket();
  return socket.connect(url);
};

// 断开websocket接口
export const disconnect = () => {
  return socket.disconnect();
};

export const stopReconnect = () => {
  return socket.stopReconnect();
};

// 检查发卡器连接状态
export const checkReader = () => {
  return socket;
};

export const registerSdk = code => {
  const { syscode, regcode } = code;
  return socket.reigster('registersdk', {
    syscode,
    regcode,
    duration: config.sdkDuration,
    interfaces: [...config.supportedInterfaces],
    // syscode: '36363631',
  });
};

export const releaseSdk = () => {
  return socket.send('releasesdk', {});
};

export const readKey = () => {
  return socket.send('readkey', { beep });
};

export const readKeyEvent = (clearAfterRead = deleteflag) => {
  return socket.send('readkeyevent', { beep, deleteflag: clearAfterRead });
};

export const registerKey = () => {
  return socket.send('registerkey', { beep });
};

export const logoutKey = () => {
  return socket.send('logoutkey', { beep });
};

export const createBlankKey = (keyid = 10) => {
  return socket.send('createblankkey', { id: keyid, beep });
};

export const createUserKey = () => {
  // TODO: 未设置过期时间，默认为1天后过期;
  // 坑1：如果不手动指定activationtime，不填experytime，默认为0000000000，导致无法开锁，指定experytime，则为当前时间+24小时，指定的值无效;
  //      如果手动指定activationtimne，不填experytime，默认为000000000，也无法开锁，指定exerytime，则为指定的值；
  // 坑2：想把能开锁的钥匙设置为不能开锁的钥匙，直接设置无效，必须要先将钥匙设置为空钥匙，再设置才可生效;
  //     而从不能开锁的钥匙设置为能开锁的钥匙，直接设置就可生效;
  return socket.send('createuserkey', {
    id: 444,
    groupid: 8,
    beep,
    activationtime: '1801010000',
    expirytime: '3001010000',
    // timezonecount: 1, //起效的时间片数量，这可以不加...
    timezonelist: [
      // 这可以不加
      {
        id: 1,
        count: 1,
        list: [
          {
            id: 1,
            begin: '1200',
            end: '2300',
            mo: 1,
            tu: 1,
            we: 1,
            th: 1,
            fr: 1,
            sa: 1,
            su: 1,
            h: 1,
            s1: 1,
            s2: 1,
          },
        ],
      },
    ],
    addplanlist: [
      { id: 888, type: 'lock', timezoneid: 1 }, // 这两个id，如果timezonelist不存在的时候，想要开锁必须不能大于2;
      { id: 9, type: 'lockgroup', timezoneid: 1 }, // 如果timezonelist里面只有一条，但是这里的timezoneid=2时，依然可以开锁...
    ],
    // calendaryear: '2018', //这也可以不加，主要是配合calendarlist设置休息日的
    // calendarlist: [{ date: '1001', type: 'h' }]
  });
};

export const createUnlockKey = (keyid = 444, beginDate, endDate, timeRanges, locksList) => {
  const planlist = locksList.map(item => {
    return { id: Number(item), type: 'lock', timezoneid: 1 };
    // id必须是数字，否则会报{"error":"Some members'(id/type/timezoneid) type is unmatched."};
  });
  const info = {
    id: keyid,
    groupid: 0,
    beep,
    activationtime: beginDate,
    expirytime: endDate,
    // timezonelist: [
    //     { id: 1, count: 1, list: [{ id: 1, begin: beginTime, end: endTime, mo: 1, tu: 1, we: 1, th: 1, fr: 1, sa: 1, su: 1, h: 1, s1: 1, s2: 1 }] }
    // ],
    timezonelist: [
      {
        id: 1,
        count: timeRanges.length,
        list: timeRanges.map((range, index) => ({
          id: index + 1,
          begin: range[0],
          end: range[1],
          mo: 1,
          tu: 1,
          we: 1,
          th: 1,
          fr: 1,
          sa: 1,
          su: 1,
          h: 1,
          s1: 1,
          s2: 1,
        })),
      },
    ],
    addplanlist: planlist,
  };
  console.log(info);
  return socket.send('createuserkey', info);
  // return socket.send('createuserkey', {

  //     id: keyid,
  //     groupid: 0,
  //     beep,
  //     activationtime: beginDateString,
  //     expirytime: endDateString,
  //     timezonelist: [
  //         { id: 1, count: 1, list: [{ id: 1, begin: beginTimeString, end: endTimeString, mo: 1, tu: 1, we: 1, th: 1, fr: 1, sa: 1, su: 1, h: 1, s1: 1, s2: 1 }] }
  //     ],
  //     addplanlist: planlist
  // })
};

export const createRegisterKey = (keyid = 11) => {
  return socket.send('createregisterkey', { id: keyid, beep });
};

export const createSettingKey = (id = 12, lockid = 888, groupid = 8) => {
  return socket.send('createsettingkey', {
    id,
    newlockid: lockid,
    newlockgroupid: groupid,
    beep,
  });
};

export const createAuditKey = (keyid = 13) => {
  return socket.send('createauditkey', { id: keyid, beep });
};

export const createVerifyKey = (keyid = 14) => {
  return socket.send('createverifykey', { id: keyid, beep });
};

export const createTraceKey = (keyid = 15) => {
  return socket.send('createtracekey', { id: keyid, beep });
};

export const createEmergencyKey = (keyid = 16, begin, end) => {
  // TODO: 这个失效日期暂时写为20年
  return socket.send('createemergencykey', {
    id: keyid,
    beep,
    activationtime: begin || '1811110000',
    expirytime: end || '3001010000',
  });
};

export const createBlacklistKey = (keyid = 17, blacklists = [444, 333]) => {
  const downloadedList = blacklists.map(item => Number(item));
  return socket.send('createblacklistkey', { id: keyid, list: downloadedList, beep });
};

export const createLogoutKey = (keyid = 18) => {
  return socket.send('createlogoutkey', { id: keyid, beep });
};
